import * as yup from "yup";

import type { TFunction } from "i18next";

/** Valores validados del reenvío manual de factura rechazada. */
export interface ResendInvoiceManualValues {
  ccEmail?: string | null;
  total: string;
}

/**
 * Fábrica del esquema de validación para el reenvío manual de factura rechazada.
 * Recibe `t` porque los mensajes de error usan claves de i18n.
 */
export const buildResendInvoiceManualSchema = (t: TFunction): yup.ObjectSchema<ResendInvoiceManualValues> =>
  yup.object().shape({
    ccEmail: yup.string().email(t("mailValid")),
    total: yup.string().required(t("isRequired")),
  }).required();
